<script context="module">
  // https://docs.affirm.com/payments/docs/html-reference
  export const AffirmPageType = Object.freeze({
    Homepage: "homepage",
    Landing: "landing",
    Search: "search",
    Category: "category",
    Product: "product",
    Cart: "cart",
    Payment: "payment",
    Banner: "banner",
    Marketplace: "marketplace",
  })

  export const AffirmClass = Object.freeze({
    AsLowAs: "affirm-as-low-as",
    SiteModal: "affirm-site-modal",
    ProductModal: "affirm-product-modal",
  })

  export const AffirmLogoType = Object.freeze({
    Default: "",
    Text: "text",
    Symbol: "symbol",
  })

  export const AffirmColor = Object.freeze({
    Default: "",
    Black: "black",
    White: "white",
  })
</script>

<script>
  // Note that Affirm will stop returning an estimate when above $30k (or around
  // there, as of this testing). They _do_ still seem to allow loans past that
  // point though, at least in the sandbox. The `empty:hidden` class prevents it
  // from taking up space when no result comes back for whatever reason.
  export let amountInCents
  export let pageType
  export let brand
  export let category
  export let sku
  export let affirmClass = AffirmClass.AsLowAs
  export let logoType = AffirmLogoType.Default
  export let color = AffirmColor.Default
  export let showLearnMore = true

  export { className as class }

  let className = ""
</script>

<p
  class="empty:hidden {className} {affirmClass}"
  data-page-type={pageType}
  data-amount={amountInCents}
  data-affirm-color={color}
  data-affirm-type={logoType}
  data-brand={brand}
  data-category={category}
  data-sku={sku}
  data-learnmore-show={showLearnMore}
/>
